import React from 'react';
import ModalOverlay from '../../shared/ModalOverlay';
import { Record } from '../../types';

interface ViewRecordModalProps {
  active: boolean;
  onClose: () => void;
  record: Record | null;
}

const ViewRecordModal: React.FC<ViewRecordModalProps> = ({ active, onClose, record }) => {
  if (!record) return null;

  const headerFields = [
    { label: 'Carrier', value: record.carrier },
    { label: 'Tail #', value: record.tail },
    { label: 'Aircraft Type', value: record.aircraft_type },
    { label: 'LDG Induction Date', value: record.ldg_induction_date },
    { label: 'LDG Delivery Date', value: record.delivery_date },
    { label: 'A/C Induction Date', value: record.induction_date },
    { label: 'Check Type', value: record.check_type },
    { label: 'Status', value: record.status },
  ];

  const bodyFields = [
    { label: 'Primary Task', value: record.primary_task },
    { label: 'Drop Dead Date', value: record.lg_drop_dead_date },
    { label: 'PO Number', value: record.po_number },
    { label: 'PO Issued Date', value: record.po_issued_date },
    { label: 'Mx 145-MRO', value: record.mx_145_mro },
    { label: 'Component Maintenance Vendor', value: record.landing_gear_vendor },
  ];

  const hasEquipment = record.equipment && record.equipment.length > 0;
  const hasContacts = record.contacts && record.contacts.length > 0;

  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal">
        <div className="modal-header">
          <h2>Record Details</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="view-header-row">
          {headerFields.map((f) => (
            <div key={f.label} className="view-field">
              <div className="label">{f.label}</div>
              <div className="val">{f.value || '\u2014'}</div>
            </div>
          ))}
        </div>

        <div className="view-grid">
          {bodyFields.map((f) => (
            <div key={f.label} className="view-field">
              <div className="label">{f.label}</div>
              <div className="val">{f.value || '\u2014'}</div>
            </div>
          ))}
          <div className="view-field full-width">
            <div className="label">Notes</div>
            <div className="val">{record.notes || '\u2014'}</div>
          </div>
        </div>

        <div style={{ padding: '0 1.5rem 1rem' }}>
          <h3 style={{ fontSize: '0.85rem', color: 'var(--text-dim)', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
            Equipment
          </h3>
          {hasEquipment ? (
            <table className="view-subtable">
              <thead>
                <tr>
                  <th>Position</th>
                  <th>Part Number</th>
                  <th>Serial Number</th>
                  <th>CSN</th>
                  <th>CSO</th>
                  <th>Drop Dead Date</th>
                </tr>
              </thead>
              <tbody>
                {record.equipment.map((eq, i) => (
                  <tr key={i}>
                    <td>{eq.position}</td>
                    <td>{eq.part_number || '\u2014'}</td>
                    <td>{eq.serial_number || '\u2014'}</td>
                    <td>{eq.csn || '\u2014'}</td>
                    <td>{eq.cso || '\u2014'}</td>
                    <td>{eq.drop_dead_date || '\u2014'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: 'var(--text-dim)', fontSize: '0.85rem' }}>No equipment assigned</p>
          )}
        </div>

        <div style={{ padding: '0 1.5rem 1rem' }}>
          <h3 style={{ fontSize: '0.85rem', color: 'var(--text-dim)', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
            Point of Contact
          </h3>
          {hasContacts ? (
            <table className="view-subtable">
              <thead>
                <tr>
                  <th>POC Name</th>
                  <th>Vendor</th>
                </tr>
              </thead>
              <tbody>
                {record.contacts.map((c, i) => (
                  <tr key={i}>
                    <td>{c.poc_name}</td>
                    <td>{c.vendor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: 'var(--text-dim)', fontSize: '0.85rem' }}>No contacts assigned</p>
          )}
        </div>

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default ViewRecordModal;
